import React, { Component } from 'react';

import { LoginHeader } from './LoginHeader';
import LoginForm from './LoginForm';
// import { LoginFooter } from './LoginFooter';
import { VerifyOTP } from './VerifyOTP';
import { restbaseurl, getRecaptchaSiteKey, isRecaptchaEnabled } from '../globals/constants';
import { RestDataSource } from '../utils/RestDataSource';
import { LoadingSpinner } from '../utils/LoadingSpinner';
import ForgotPassword from './ForgotPassword';
import BottomAlert from '../globals/uicomps/BottomAlert'
import ResetPassword from './ResetPassword';
import PhotoAuthenticator from "./PhotoAuthenticator"
import AccountSuspend from './AccountSuspend';
import TryAnotherWays from "./TryAnotherWays"
import Authenticator from './Authenticator';
import { Route, Routes } from "react-router-dom";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import md5 from 'md5';
import UserInfo from '../models/UserInfo';
import { getValue, setValue, setAllValue } from '../globals/utils';
import { encryptionKey } from '../globals/constants'
import * as ls from "local-storage";
import { WithRouterHooks } from 'withFunctionHooks';

class LoginLayout extends Component {

     constructor(props) {
          super(props);
          let index = this.props.location.pathname.lastIndexOf("/");
          let step = this.props.location.pathname.substr(index + 1).trim()
          this.state = {
               alertMsg: null,
               role: null,
               userData: null,
               forgotPassword: false,
               otpVerified: false,
               isSuspended: false,
               anotherWay: false,
               isAuthMFAEnabled: null,
               isAuthPhotoEnabled: null,
               step: (step === '' || step === 'home') ? 'login' : step,
               fullLoading: false,
               payloadData: null
          };
          this.userId = UserInfo.getUserid()
          this.username = UserInfo.getUsername();
          this.userName = '';
          this.updateLoginData()
     }

     componentDidMount = () => {
          document.body.classList.add('login-bg')
          this.redirectIfLoggedIn();
     }

     updateLoginData = () => {
          return new Promise((resolve) => {
               getValue().then((pData) => {
                    if (!pData) {
                         this.setState({
                              payloadData: null

                         })
                         this.changeStepValue("login");
                         resolve();
                    } else {
                         this.setState({
                              payloadData: pData,
                              role: pData['roleCode'],
                              isAuthMFAEnabled: pData['authenticatorEnabled'],
                              isAuthPhotoEnabled: pData['faceIdEnabled']
                         }, () => {
                              resolve();
                         });
                    }
               })
          })

     }

     redirectIfLoggedIn = () => {
          getValue().then(async (payloadData) => {
               if (payloadData && payloadData['isloggedin'] === true) {
                    await this.redirectWithPayload(payloadData);
                    return;
               }
               this.setState({ fullLoading: false });
          }).catch(() => {
               this.setState({ fullLoading: false });
          });
     }

     validateLogin = async (username, password) => {
          password = password.trim()
          this.dataSource = new RestDataSource(`${restbaseurl}/login/auth`)
          this.setState({ loading: true, alertMsg: null });

          try {
               // Encrypt credentials before sending (OWASP A02:2021 - Cryptographic Failures)
               const { encryptCredentials } = await import('../utils/CredentialEncryption');
               const encryptedCreds = await encryptCredentials(username, password);

               this.dataSource.GetData(
                    respData => {
                         // Always reset loading state first
                         if (respData.message === 'success') {
                              (respData.data['authenticatorEnabled'] || respData.data['faceIdEnabled']) ?
                                   this.setState({ loading: false, userdata: respData.data, step: 'tryAnotherWays', alertMsg: null })
                                   //: this.setState({ loading: false, userdata: respData.data, step: 'verifyOtp', alertMsg: null }, () => this.triggerOtp())
                                   : this.setState({ loading: false }, () => this.loginSuccess(respData.data))
                         }
                         else if (respData.isBlocked === true) {
                              this.setState({ loading: false, step: 'blocked' })
                         }
                         else if (respData.concurrentSession === true) {
                              // Handle concurrent session - this should not happen now as we allow concurrent login
                              // But keep this for backward compatibility
                              this.setState({
                                   loading: false,
                                   alertMsg: respData.message || 'This account is already logged in from another device. Please logout from the active session to continue.'
                              });
                         }
                         else if (respData.error) {
                              // Handle server error responses
                              this.setState({ loading: false, alertMsg: respData.error });
                         }
                         else {
                              // Generic message handling (includes invalid credentials, etc.)
                              this.setState({ loading: false, alertMsg: respData.message || 'Login failed. Please try again.' });
                         }
                    },
                    { "username": encryptedCreds.username, "password": encryptedCreds.password, "gtoken": "test" },
                    "POST"
               );
          } catch (error) {
               console.error('Login error:', error);
               this.setState({ loading: false, alertMsg: 'Network error. Please check your connection and try again.' });
          }
     }

     validateDetails = (userName, email) => {
          this.checkDetails = new RestDataSource(`${restbaseurl}/login/forgotPassword`)
          this.setState({ loading: true });
          this.checkDetails.GetData(
               async (respData) => {
                    this.setState({ loading: false });

                    // SECURITY: Backend now returns generic message to prevent user enumeration
                    // Show the message to user
                    if (respData.status) {
                         this.showAlert(respData.message);
                         // Store username and email for OTP verification if user proceeds
                         // Also set isForgotPassword: true so setAllValue stores it in local storage
                         // This is REQUIRED so VerifyOTP component can load the data via getValue()
                         const payloadData = respData.data || {};
                         const payload = {
                              isForgotPassword: true,
                              userId: payloadData.userId || null,
                              username: payloadData.username || userName,
                              email: payloadData.email || email,
                              otpExpiryTime: respData.otpExpiryTime || 300000
                         };

                         this.setState({
                              forgotPasswordUsername: userName,
                              forgotPasswordEmail: email
                         });

                         // Save to local storage so VerifyOTP can read it
                         await setAllValue(payload);

                         // Redirect to OTP verification page after showing message
                         setTimeout(() => {
                              this.setState({ step: 'verifyOtp' }, () => {
                                   this.props.navigate(`/home/${this.state.step}`);
                              });
                         }, 2000);
                    } else {
                         this.showAlert(respData.message || 'An error occurred. Please try again.');
                    }
               },
               { "userName": userName, "email": email },
               "POST"
          );
     }

     resendOTP = () => {
          this.checkResend = new RestDataSource(`${restbaseurl}/login/resendOtp`)
          this.showAlert(null);
          this.setState({ loading: true }, () => {
               this.checkResend.GetData(
                    async resendResponse => {
                         this.setState({ loading: false })
                         if (resendResponse.isBlocked) {
                              this.changeStepValue("blocked")
                         }
                         else {
                              await setValue('remainingTries', resendResponse.remainingTries)
                         }
                    },
                    { 'userId': UserInfo.getUserid(), "username": UserInfo.getUsername() },
                    "POST"
               );
          })
     }

     triggerOtp = () => {
          this.otpRequest = new RestDataSource(`${restbaseurl}/login/triggerOtp`);
          this.setState({ loading: true });
          this.otpRequest.GetData(
               async respData => {
                    if (respData.status === 'success') {
                         if (respData.isBlocked) {
                              this.changeStepValue("blocked");
                         } else {
                              await setValue('remainingTries', respData.remainingTries);
                         }
                    } else {
                         this.showAlert(respData.message)
                    }
                    this.setState({ loading: false });
               },
               { "userId": UserInfo.getUserid() },
               "POST"
          );
     }

     verifyOTP = (otp) => {
          this.updateLoginData().then(() => {
               this.verifyOTPReq = new RestDataSource(`${restbaseurl}/login/otpLogin`)
               this.showAlert(null);
               this.setState({ loading: true }, () => {
                    this.verifyOTPReq.GetData(
                         respData => {
                              if (respData.message === 'success') {
                                   if (this.state.payloadData['isForgotPassword']) {
                                        this.changeStepValue("resetPassword")
                                        this.setState({ loading: false })
                                   }
                                   else {
                                        this.loginSuccess(respData.data);
                                   }
                              }
                              else {
                                   if (respData.isBlocked === true) {
                                        this.changeStepValue("blocked")
                                   }
                                   else {
                                        this.showAlert(respData.message)
                                   }
                                   this.setState({ loading: false })
                              }
                         },
                         { 'userId': UserInfo.getUserid() ? UserInfo.getUserid() : this.state.payloadData['userId'], "username": UserInfo.getUsername() ? UserInfo.getUsername() : this.state.payloadData['username'], "otp": otp },
                         "POST"
                    );
               })
          })

     }

     loginSuccess = async (userData = null) => {
          // build payload from response; minimal fallback
          let payloadData = {};
          if (userData) {
               const normalizedRoles = (userData.roleCodeList || []).map(r => (r || '').toLowerCase());
               const roleCode = userData.roleCodeList && userData.roleCodeList.length ? userData.roleCodeList[0] : userData.roleCode;
               const roleCodeNorm = (roleCode || '').toLowerCase();
               // derive roleId if not present
               let roleId = userData.roleId;
               if (!roleId && roleCode && userData.roleList && Array.isArray(userData.roleList)) {
                    const found = userData.roleList.find(r => (r.code || '').toLowerCase() === (roleCode || '').toLowerCase());
                    roleId = found ? found.id : '';
               }
               const rolePriority = (userData.rolePriorityList && userData.rolePriorityList.length) ? userData.rolePriorityList[0] : userData.rolePriority;

               // derive admin/chp/ops flags (mirrors RestDataSource login handling)
               let isAdminOrChp = ['admin', 'operationshead', 'chp'].includes(roleCodeNorm) || normalizedRoles.some(r => ['admin', 'operationshead', 'chp'].includes(r));
               let isLoggedByOperations = roleCodeNorm === 'operations' || normalizedRoles.includes('operations');
               const rpList = userData.rolePriorityList || [];
               const rm = userData.roleMap || {};
               if (!isAdminOrChp && rpList.length) {
                    if (rm['admin'] !== undefined && rpList.includes(rm['admin'])) isAdminOrChp = true;
                    if (rm['operationshead'] !== undefined && rpList.includes(rm['operationshead'])) isAdminOrChp = true;
                    if (rm['chp'] !== undefined && rpList.includes(rm['chp'])) isAdminOrChp = true;
               }
               if (!isLoggedByOperations && rpList.length) {
                    if (rm['operations'] !== undefined && rpList.includes(rm['operations'])) isLoggedByOperations = true;
               }

               payloadData = {
                    isloggedin: true,
                    isForgotPassword: false,
                    userId: userData.userId,
                    username: userData.username,
                    roleId: roleId,
                    clientId: userData.clientId,
                    clientLogo: userData.clientLogo,
                    applicantId: userData.applicantId,
                    firstTimeLogin: userData.firstTimeLogin,
                    loginname: userData.firstname,
                    clientEmail: userData.clientEmail,
                    otpExpiryTime: userData.otpExpiryTime,
                    mobilenumber: userData.mobilenumber,
                    authenticatorEnabled: userData.authenticatorEnabled,
                    accessibleTabs: userData.accessibleTabs,
                    accessExpiryTime: userData.accessExpiryTime,
                    showBilling: userData.showBilling,
                    faceIdEnabled: userData.faceIdEnabled ?? userData.faceIdEnabled === false ? userData.faceIdEnabled : true,
                    roleList: userData.roleList,
                    rolePriorityList: userData.rolePriorityList,
                    roleCodeList: userData.roleCodeList,
                    roleMap: userData.roleMap,
                    roleCode: roleCode,
                    rolePriority: rolePriority,
                    rolePath: userData.rolePath || '',
                    clientCode: userData.clientCode,
                    chatBotUrl: userData.chatBotUrl,
                    metaPyraUrl: userData.metaPyraUrl,
                    isAdminOrChp,
                    isLoggedByOperations
               };
          } else {
               payloadData = await getValue() || {};
               payloadData.isloggedin = true;
          }

          await setAllValue(payloadData);
          this.setState({ fullLoading: true });
          document.body.classList.remove('login-bg');
          await this.redirectWithPayload(payloadData);
     }

     redirectWithPayload = async (payloadData) => {
          if (payloadData && payloadData['isloggedin'] === true) {
               const roleCodeList = (payloadData['roleCodeList'] || []).map(r => String(r || '').toLowerCase());
               const hasMultipleRoles = roleCodeList.length > 1;
               const hasAdminRole = roleCodeList.includes('admin');

               // Don't show role selection: single role OR user has admin role (default to admin)
               if (hasMultipleRoles && !hasAdminRole) {
                    this.props.navigate("/chooseRole");
                    return;
               }

               let role = payloadData['roleCode'];
               if ((!role || role === '') && payloadData['roleCodeList'] && payloadData['roleCodeList'].length) {
                    // Multiple roles with admin: default to admin for X-Acting-Role; else first role
                    role = hasAdminRole ? 'admin' : payloadData['roleCodeList'][0];
               }
               const roleNorm = (role || '').toLowerCase();

               // Set default roleCode in payload so X-Acting-Role header is sent correctly (single role or admin default)
               if (roleNorm) {
                    const roleList = payloadData['roleList'] || [];
                    const roleObj = roleList.find(r => String(r?.code || '').toLowerCase() === roleNorm);
                    payloadData.roleCode = roleNorm;
                    if (roleObj) {
                         payloadData.roleId = roleObj.id;
                         if (payloadData.roleMap && payloadData.roleMap[roleNorm] != null) {
                              payloadData.rolePriority = payloadData.roleMap[roleNorm];
                         }
                    }
                    if (roleNorm === 'admin') {
                         payloadData.rolePath = 'adminDashboard';
                         payloadData.isAdminOrChp = true;
                    } else if (!payloadData.rolePath) {
                         payloadData.rolePath = payloadData.isAdminOrChp ? 'adminDashboard' : 'dashboard';
                    }
                    await setAllValue(payloadData);
               }

               let redirectUrl = '/dashboard';
               if (roleNorm === 'vendor') {
                    redirectUrl = "/vendorDashboard";
               } else if (roleNorm === 'operations') {
                    redirectUrl = "/operations";
               } else if (roleNorm === 'de') {
                    redirectUrl = "/dataEntry";
               } else if (roleNorm === 'reportviewer') {
                    redirectUrl = "/reportViewerDashboard";
               } else if (roleNorm === 'documentviewer') {
                    redirectUrl = "/documentViewerDashboard";
               } else if (roleNorm === 'qc') {
                    redirectUrl = "/qcDashboard";
               } else if (payloadData['isAdminOrChp']) {
                    redirectUrl = "/adminDashboard";
               } else if (payloadData['firstTimeLogin'] === true) {
                    redirectUrl = "/onboarding";
               } else {
                    redirectUrl = "/dashboard";
               }
               this.props.navigate(redirectUrl);
               return;
          }
          this.setState({ fullLoading: false });
     }

     changeStepValue = (stepValue, userName) => {
          if (stepValue === 'verifyOtp') {
               this.triggerOtp();
          }
          this.userName = userName;
          this.setState({ step: stepValue }, () => {
               this.props.navigate(`/home/${this.state.step}`);
          });
     }

     showAlert = (alertMsg) => {
          this.setState({ alertMsg: alertMsg });
     }

     render = () => {
          let path = '/home';

          return (

               <React.Fragment>

                    {/* <Router> */}
                    <GoogleReCaptchaProvider reCaptchaKey={getRecaptchaSiteKey()}>
                         {this.state.fullLoading ? <LoadingSpinner showBg="true" /> :
                              <React.Fragment>
                                   <LoginHeader />
                                   <div className="login-block">
                                        <div className="login-set">
                                             {
                                                  this.state.loading === true ? <LoadingSpinner showBg="true" /> :
                                                       <React.Fragment>
                                                            {
                                                                 (this.state.alertMsg) ? <BottomAlert status="danger" msg={this.state.alertMsg} /> : null
                                                            }
                                                            {
                                                                 <Routes>
                                                                      <Route path={`/home/verifyOtp`} element={<VerifyOTP {...this.props} {...this.state.userdata} showAlert={this.showAlert} loginSuccess={this.loginSuccess} changeStepValue={this.changeStepValue} resendOTP={this.resendOTP} verifyOTP={this.verifyOTP} />} />
                                                                      <Route path={`/home/tryAnotherWays`} element={<TryAnotherWays {...this.props} {...this.state.userdata} showAlert={this.showAlert} changeStepValue={this.changeStepValue} />} />
                                                                      <Route path={`/home/photoAuthenticator`} element={<PhotoAuthenticator {...this.props} {...this.state.userdata} showAlert={this.showAlert} changeStepValue={this.changeStepValue} />} />
                                                                      <Route path={`/home/authenticator`} element={<Authenticator {...this.props} {...this.state.userdata} showAlert={this.showAlert} changeStepValue={this.changeStepValue} loginSuccess={this.loginSuccess} />} />
                                                                      <Route path={`/home/forgotPassword`} element={<ForgotPassword {...this.props} userName={this.userName} forwardToOtp={this.validateDetails} changeStepValue={this.changeStepValue} />} />
                                                                      <Route path={`/home/resetPassword`} element={<ResetPassword {...this.props} showAlert={this.showAlert} loginSuccess={this.loginSuccess} changeStepValue={this.changeStepValue} />} />
                                                                      <Route path={`/home/blocked`} element={<AccountSuspend {...this.props} changeStepValue={this.changeStepValue} />} />
                                                                      <Route path={`/home/login`} element={<LoginForm {...this.props} cbValidateLogin={this.validateLogin} changeStepValue={this.changeStepValue} hideForgotPassword={false} />} />

                                                                 </Routes>
                                                            }

                                                       </React.Fragment>
                                             }
                                        </div>
                                        <div className="clr"></div>
                                   </div>
                              </React.Fragment>
                              /* <LoginFooter /> */
                         }
                         <img className="loginbg" src={'/images/login-bg.svg'} alt='' />
                    </GoogleReCaptchaProvider>
               </React.Fragment>
          );
     }
}

export default WithRouterHooks(LoginLayout);
// Also export named for existing imports
export { LoginLayout };

//
/*



     */



